export default "__VITE_ASSET__CrB4tJXJ__"